import { Box, Button, ButtonGroup } from "@mui/material";
import TextField from "@mui/material/TextField";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState
} from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { toast } from "react-toastify";
import CardDataLoader from "../../../uiComponents/CardDataLoader/CardDataLoader";
import { yearToAge } from "../../../utility/ageToYear";
import { bdDateFormat } from "../../../utility/dateConversion";

const axios = require("axios").default;

const PatientList = forwardRef((props, ref) => {
  // state
  const [isLoading, setIsLoading] = useState(true);
  const [patientList, setPatientList] = useState([]);
  const [tableFontSize, setTableFontSize] = useState(17);
  const [confirmDeleteId, setConfirmDeleteId] = useState(0);
  // state

  // special
  useImperativeHandle(ref, () => ({
    getPatientList,
  }));
  // special //

  // handle Managemnt

  const handleFontSizeChange = (value) => {
    setTableFontSize(value);
    localStorage.setItem("style_patientList_fontSize", value);
  };

  
  const handleDelete = (item) => {
    console.log(item);
    // getOrderListByPatientId(patientIdRedux);
    setIsLoading(true);
    axios.delete("dentrino-patient-info/"+item.id)
    .then(response=>{
      
      setIsLoading(false);
      
      getPatientList();
      console.log(response)
      // toast.info("Patient ID: "+item.id+ " delete success.")
    })
    .catch(error=>{
      setIsLoading(false);
      toast.error("Something is wrong")
      console.log(error)
    })
  };
  // handle Managemnt  //

  // dataTable sectins
  const getLocalStyle = () => {
    const localFontSize = localStorage.getItem("style_patientList_fontSize");
    console.log("localFontSize-101", localFontSize, typeof localFontSize);
    typeof localFontSize === "string"
      ? setTableFontSize(localFontSize)
      : setTableFontSize(17);
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => `${row.id} - ${row.custom_id}`,
    },
    {
      name: "Patient Name",
      selector: (row) => row.patient_name,
      sortable: true,
    },
    {
      name: "Age",
      width: "70px",
      selector: (row) =>
        yearToAge(row.dentrino_patient_personal_info.dateofbirthyear),
    },
    {
      name: "Sex",
      width: "80px",
      selector: (row) => (row.gender === "1" ? "Male" : "Female"),
    },
    {
      name: "Mobile",
      width: "130px",
      selector: (row) => row.phone_number,
    },
    {
      name: "Address",
      selector: (row) => row.address,
    },
    {
      width: "130px", 
      name: "Entry Date",
      selector: (row) => bdDateFormat(row.created_at),
    },
    {
      name: "Doctor name",
      selector: (row) => {
        return row.dentrino_doctors_manager.doctor_name;
      },
    },
    {
      name: "Action",
      selector: (row) => {
        const itemId = row.id;
        return (
          <ButtonGroup variant="outlined" aria-label="outlined button group">
            {confirmDeleteId === row.id ? (
              <>
                <Button
                  onClick={() => handleDelete(row)}
                  sx={{fontSize:"10px"}}
                  color="error"
                  variant="contained"
                >
                  CONFIRM DEL
                </Button>
                <Button 
                  sx={{fontSize:"10px"}}
                color="warning" onClick={() => setConfirmDeleteId(0)}>
                  CANCEL
                </Button>
              </>
            ) : (
              <>
                <Button
                  onClick={() => props.handleOpenPatientDetails(itemId)}
                  color="success"
                >
                  DETAILS
                </Button>
                <Button color="error" onClick={() => setConfirmDeleteId(row.id)} >DELTE</Button>
              </>
            )}
          </ButtonGroup>
        );
      },
    },
  ];
  createTheme(
    "solarized",
    {
      text: {
        primary: "#268bd2",
        secondary: "#2aa198",
      },
      background: {
        default: "#002b36",
      },
      context: {
        background: "#cb4b16",
        text: "#FFFFFF",
      },
      divider: {
        default: "#073642",
      },
      action: {
        button: "rgba(0,0,0,.54)",
        hover: "rgba(0,0,0,.08)",
        disabled: "rgba(0,0,0,.12)",
      },
    },
    "dark"
  );
  createTheme(
    "dentrino",
    {
      text: {
        fontSize: "30px",
      },
    },
    "light"
  );
  const customStyles = {
    rows: {
      style: {
        fontSize: tableFontSize + "px",
        // fontSize: "17px",
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        fontSize: tableFontSize + "px",
        fontWeight: 600,
        // fontSize: "20px",
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
      },
    },
  };
  // dataTable sectins //
  // axios
  const getPatientList = () => {
    setIsLoading(true);
    axios
      .get("/dentrino-patient-manager")
      .then((response) => {
        setIsLoading(false);
        console.log(response.data);
        setPatientList(response.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };
  // axios //
  // useEffect
  useEffect(() => {
    getLocalStyle();
    getPatientList();
  }, []);
  // useEffect //

  return (
    <div>
      {/* <Box sx={{ fontSize: "30px", marginBottom: 3, marginTop: 3 }}>
        PATIENT LIST
      </Box> */}
      <Box sx={{ position: "relative" }}>
        {isLoading && <CardDataLoader></CardDataLoader>}
        <DataTable
          columns={columns}
          data={patientList}
          direction="auto"
          fixedHeaderScrollHeight="300px"
          highlightOnHover
          pagination
          responsive
          striped
          subHeaderAlign="right"
          subHeaderWrap
          theme="dentrino"
          customStyles={customStyles}
        />
      </Box>
      <Box sx={{ marginTop: 3 }}>
        <TextField
          label="Font Size"
          value={tableFontSize}
          onChange={(e) => handleFontSizeChange(e.target.value)}
          size="small"
          sx={{ width: 70 }}
          type="number"
        />
      </Box>
    </div>
  );
});

export default PatientList;
